import { Company } from './company.model';
import { Department } from './department.model';
import { Industry } from './industry.model';

export class WorkRecord {

  constructor(
    public company: Company,
    public industry: Industry,
    public department: Department
  ) { }

}



// WEBPACK FOOTER //
// /dist/src/app/user/work-record/work-record.model.ts